module.exports = __webpack_public_path__ + "static/feature_portal-4e1955d8fc07a363be8d47119769a538.png";